// @flow

const savedSearchItemSortOrders = {
    NEWLY_LISTED: 'newlyListed',
    STARTING_SOONEST: 'starting',
};

export default savedSearchItemSortOrders;
